import {AgencyConfigFiles} from "../app/api.config";
import {AgencyConfigData} from "../model/Agency";
import {Injectable} from "@angular/core";

@Injectable()
export class AgencyConfigService {

  agencyConfigFiles: any = new AgencyConfigFiles();
  agencyConfigData: AgencyConfigData = new AgencyConfigData();

  constructor() {
    let hostname = window.location.hostname;
    let configFile = this.agencyConfigFiles.defaultConfig;


    if (typeof this.agencyConfigFiles.hosts[hostname] !== 'undefined') {
      configFile = this.agencyConfigFiles.hosts[hostname];
    }

    console.log("AgencyConfigService : hostName:" + hostname + ", configFile=" + configFile);

    if (typeof this.agencyConfigFiles.config[configFile] !== 'undefined') {
      this.agencyConfigData = this.agencyConfigFiles.config[configFile];
    }
  }

  getAgencyConfigData(): AgencyConfigData {
    return this.agencyConfigData;
  }

}



// WEBPACK FOOTER //
// ./src/services/AgencyConfigService.ts